import { allValues, Rights } from '../rights';

export const KITCHEN_MANAGEMENT_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.GENERAL.READ.key,
  Rights.RESIDENTS.CONTRACT.READ.key,
  Rights.RESIDENTS.CONTACTS.READ.key,
  Rights.RESIDENTS.CONSULTATION.READ.key,
  Rights.RESIDENTS.UTILS.READ.key,
  Rights.RESIDENTS.PASTORAL_CARE.READ.key,
  Rights.RESIDENTS.DOCUMENT_MANAGEMENT.READ.key,
  Rights.EMPLOYEES.READ.key,
  Rights.EMPLOYEES.GENERAL.READ.key,
  Rights.EMPLOYEES.CONTRACT.READ.key,
  Rights.EMPLOYEES.CHECKLIST.READ.key,
  Rights.EMPLOYEES.FILES.READ.key,
  Rights.EMPLOYEES.WORK.READ.key,
  Rights.EMPLOYEES.CALENDAR.READ.key,
  Rights.EMPLOYEES.VACATION.READ.key,
  Rights.EMPLOYEES.MISC.READ.key,
  Rights.EMPLOYEES.TRAINING.READ.key,
  Rights.BASE_DATA.SUPERVISOR.READ.key,
  ...allValues(Rights.CARE.BIOGRAPHY),
  ...allValues(Rights.CARE.NUTRITION_PROTOCOL),
  Rights.CARE.READ.key,
  Rights.CARE.CARE_PLAN.READ.key,
  Rights.CARE.NURSE_VISIT.READ.key,
  Rights.GENERAL.CASH_AMOUNT.READ.key,
  ...allValues(Rights.GENERAL.CALENDAR),
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.MANAGE.key,
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.ACCESS.WRITE.key,
  Rights.ROSTER.WEEK_PLAN.key,
  Rights.LISTS.READ.key,
  Rights.LISTS.WRITE.key,
  ...allValues(Rights.ROSTER.VACATION_SCHEDULE),
]);
